<template>
	<v-dialog
			:value="isViewPositions"
			content-class="dialogWrapper"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>View position</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="fieldWrapper">
					<field
							:class-error="getError('name')"
							margin="0"
							width="100%"
							label="Positions name"
							placeholder="Enter position name"
							:setInputValue="name"
							@updateInput="onInput($event, 'name')"
							is-required
					></field>

					<field
							:classError="$v.department_id.$error"
							margin="0"
							width="100%"
							label="Department"
							placeholder="Select department"
							@updateAutocomplete="onAutocomplete($event, 'department_id')"
							:autocompleteValue="department_id"
							:items="itemsDepartments"
							:isClearable="false"
							item-text="name"
							item-value="id"
							is-autocomplete
							is-required
					></field>
				</div>
				<div class="main">

				</div>
				<div class="footer">
					<custom-btn
							text="Save"
							@updateEvent="onSave"
							custom-class="apply"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'safe'}"
					></custom-btn>
					<custom-btn
							text="Close"
							@updateEvent="onClose"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'close'}"
					></custom-btn>
				</div>
			</div>
		</div>
		<preload v-if="isPreloader"></preload>

	</v-dialog>
</template>

<script>

import Vue from 'vue';

// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from 'v-mask';
Vue.use(VueMask);

// validation
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { mapActions, mapGetters } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
export default {
	name: "ViewPositions",
	components: { Preload },
	computed: {
		...mapGetters([
			'itemsDepartments',
			'editPositions',
		]),
	},
	mixins: [ validationMixin ],
	props: {
		dialogFlag: String,
	},

	validations: {
		name: { required },
		department_id: { required },
	},
	data: () => ({
		isViewPositions: true,
		name: null,
		id: null,
		department_id: null,
		isPreloader: false,
	}),

	methods: {
		...mapActions([ 'setAlert', 'onAccountPositionsSave', 'onAccountPositionsEdit', 'getAccountDepartmentsList', ]),

		onAutocomplete({ value }, key) {
			this[key] = value?.id ?? value;
		},

		onInput({ value }, key) {
			this[key] = value;
		},
		onTime(value, key) {
			this[key] = value;
		},

		async onSave() {
			this.isPreloader = true;

			this.$v.$touch();
			if (!this.$v.$error) {
				const { name, department_id, id } = this.$data;
				const sendInfo = { name, department_id };

				if (this.dialogFlag === 'add') {
					await this.onAccountPositionsSave({ sendInfo });
				} else {
					await this.onAccountPositionsEdit({ sendInfo, id });
				}
				this.$emit('updateClose');
				this.$emit('updateList');
			} else {
				await this.setAlert({ type: "error", message: "Saving error" });
			}
			this.isPreloader = false;

		},

		onClose() {
			this.$emit('updateClose');
		},

		getError(key) {
			return this.$v && this.$v[key] && this.$v[key].$error;
		},
	},
	async mounted() {
		this.isPreloader = true;

		await this.getAccountDepartmentsList();
		if (this.dialogFlag === 'add') {
			this.name = null;
			this.department_id = null;
			this.id = null;
		} else {
			this.name = this.editPositions.name;
			this.department_id = this.editPositions.department_id;
			this.id = this.editPositions.id;
		}

		this.isPreloader = false;
	},
};
</script>

<style scoped lang="scss">
@import "../ViewVersion/ViewVersion";
</style>
